import React from 'react'
import LocationIcon from '../MenuImages/Marker.png';
import PhoneIcon from '../MenuImages/Phone.png';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import '../../fonts/font.css'
import  './cards.css';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import SearchIcon from '../../images/NavBarImages/Multiply_100px.png';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import CartForm from './Forms/CartForm'
import DetailsForm from './Forms/DetailsForm'
import ItemsForm from './Forms/ItemsForm'
import GroupForm from './Forms/GroupForm'


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2B2B2B',
    color: 'white',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));
const MainMenuCards = ({CartCount,cart,Groups,Items,SelectedType,ShowDetails,LanguageID,ItemDetails ,SubsecriptionType,RestInformation,ItemCount,setItemCount,Dcrement,Increment,  CartTotalPrcice ,  CartTotalDiscount,DeliveryTransPrice,setDeliveryTransPrice,ItemSize,SelectedItemSize,setSelectedItemSize,ThemeColor,ItemNote,setItemNote ,PromoCodeStatus, ListOfPromoCode,getBranchPromoCode,PromoCode,PromoCodeStatusChick,handleTryAgain,DBTransListPrice,setCostAddress,CostAddress,ShowAddressBar,setShowAddressBar,  ShowAddress
              ,ServiceStatus
              ,ServicPrice}) => {
  return (

    <div >
       {SelectedType === 'Group' && (

         <GroupForm CartCount={CartCount} SelectedType={SelectedType} Groups={Groups} ShowDetails={ShowDetails}LanguageID={LanguageID} RestInformation={RestInformation} ></GroupForm>
           
         
        ) } 
        
        
        
        {SelectedType === 'Item' && (
                 

         <ItemsForm CartCount={CartCount} SelectedType={SelectedType} Items={Items} ShowDetails={ShowDetails}LanguageID={LanguageID} RestInformation={RestInformation} ThemeColor={ThemeColor}></ItemsForm>
        

        )}


      {SelectedType === 'Details' && (
              <DetailsForm  ItemDetails={ItemDetails} ShowDetails={ShowDetails}LanguageID={LanguageID}  ItemSize={ItemSize}SelectedItemSize={SelectedItemSize}setSelectedItemSize={setSelectedItemSize} ThemeColor={ThemeColor} ItemNote={ItemNote}setItemNote={setItemNote} ></DetailsForm>
           

            )}



        {(SelectedType === 'Cart' || SelectedType=='Continue') && (
             <CartForm  cart={cart} LanguageID={LanguageID}  ItemCount={ItemCount} setItemCount={setItemCount} Dcrement={Dcrement} Increment={Increment}  CartTotalPrcice={CartTotalPrcice}   CartTotalDiscount={CartTotalDiscount}DeliveryTransPrice={DeliveryTransPrice} setDeliveryTransPrice={setDeliveryTransPrice} ThemeColor={ThemeColor}  PromoCodeStatus={PromoCodeStatus}  ListOfPromoCode={ListOfPromoCode}getBranchPromoCode={getBranchPromoCode} PromoCode={PromoCode} PromoCodeStatusChick={PromoCodeStatusChick} handleTryAgain={handleTryAgain} DBTransListPrice={DBTransListPrice}setCostAddress={setCostAddress} CostAddress={CostAddress} ShowAddressBar={ShowAddressBar}setShowAddressBar={setShowAddressBar}   ShowAddress={ShowAddress} SubsecriptionType={SubsecriptionType}
             ServiceStatus={ServiceStatus}
             ServicPrice={ServicPrice}></CartForm>

        )}
   </div>
   


  )
}


export default MainMenuCards


